export default "__VITE_ASSET__Dc3b9o$6__"